import styled from "styled-components";

export const RowRenderStyle = styled.div`
  word-wrap: break-word;
  word-break: break-word;
`;

export const InputFieldStyled = styled.div`
  .ant-select-selection-item {
    font-size: 14px;
  }
  margin: -10px;
  width: 128px;
`;

export const StarIcon = styled.img`
  width: 16px;
  height: 16px;
  margin-left: 12px;
  margin-bottom: 3px;
`;

export const NameWrapper = styled.div`
  display: flex;
  align-items: center;
`;